import { Category, Metadata } from "../../components/common/Common";
import { MapSearchOptions } from "../../components/common/MapListView";
import { POISearchOptions } from "../../components/map/sidesheet/SearchPOI";
import { Method } from "../Config";
import { ResponseType, Gateway } from "./Gateway";

interface ListSearchReqBody {
    count?: number;
    page?: number;
    filter?: POISearchOptions | MapSearchOptions;
    sortBy?: string;
    direction?: string;
}

interface MapQueryParams {
    mapid: string;
}

interface SaveMapReqBody {
    email?: string;              // (MapComplete.tsx > local) 지도를 공유할 사용자 이메일
    sld?: string;                // (CreateMap.tsx > MapSaveData) 마커 정보, markerInfo
    title?: string;              // (MapComplete.tsx > local) 지도 제목
    desc?: string;               // (MapComplete.tsx > local) 지도 설명
    category?: Category[];       // (??) 카테고리 설정 및 스타일 (구현 x)
    metadata?: Metadata;         // (??) 지도 메타데이터 (구현 x)
    mapType?: string;            // (CreateMap.tsx > MapSaveData) 배경지도 종류(baroEMap, OSM)
    geoJSON?: string;            // (CreateMap.tsx > MapSaveData) 지도 데이터
    privateMap?: number;         // (CreateMap.tsx > MapSaveData) 지도 공개 여부
    thumbnail?: string;          // (MapComplete.tsx > local) 지도 정보 썸네일(스크린샷)
    infoStyle?: string;          // (??) 주요 정보 설정 및 스타일
    keyword?: string[];          // (MapComplete.tsx > local) 지도 정보 키워드
}

interface KMLQueryParams extends MapQueryParams {
    title: string;
}

interface MapInfoReqBody {
    properties: MapInfoOptions[];
}

interface FeatureListReqBody {
    page?: number;
    count?: number;
    filter?: { [key: string]: string }; // NOTE mjkang 추후 필터 기능이 추가될 것을 고려해 타입 러프하게 지정함
    ogcfilter?: { [key: string]: string };
    detail?: boolean;
}

export type MapInfoOptions = "title" | "desc" | "keyword" | "category" | "userId" | "famousMarker";

class MapGateway extends Gateway {
    protected readonly _contextPath = "map";
    protected readonly _pathParams?: { [key: string]: string };
    protected readonly _processParams = {
        list: "list",
        save: "save",
        recommend: "recommend",
        info: "info",
        metadata: "metadata",
        count: "count",
        kml: "kml",
        view: "view",
        delete: "delete",
        update: "update",
        getfeature: "getfeature",
    };

    public async reqMapSave(body: SaveMapReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.save,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqMapCount(): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.count,
        };

        return await this.request(Method.GET, undefined, queryParam);
    }

    public async reqRecommendMapList(): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.recommend,
        };
        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqMapList(body: ListSearchReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.list,
        };
        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqMapInfoData(query: MapQueryParams, body?: MapInfoReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.info,
            ...query,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqMapMetadata(query: MapQueryParams, body?: MapInfoReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.metadata,
            ...query,
        };
        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqKML(query: KMLQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.kml,
            ...query,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqUpdateViewCnt(query: MapQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.view,
            ...query,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqDeleteMap(query: MapQueryParams): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.delete,
            ...query,
        };

        return await this.request(Method.POST, undefined, queryParam);
    }

    public async reqUpdateMapInfo(query: MapQueryParams, body: SaveMapReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.update,
            ...query,
        };

        return await this.request(Method.POST, undefined, queryParam, body);
    }

    public async reqFeatureList(param: MapQueryParams, body?: FeatureListReqBody): Promise<ResponseType> {
        const queryParam = {
            process: this._processParams.getfeature,
            ...param,
        };
        return await this.request(Method.POST, undefined, queryParam, body);
    }    
}

export { 
    MapGateway, type MapQueryParams, type SaveMapReqBody, type MapInfoReqBody, type KMLQueryParams, type FeatureListReqBody, type ListSearchReqBody};
